import { api } from '@/shared/lib/api'
import type { BenefitVoucher, VoucherRedeemPayload, VoucherFilters, VoucherPaginatedResponse } from '../types'

export const vouchersService = {
  getAll: async (filters: VoucherFilters): Promise<VoucherPaginatedResponse> => {
    const params: Record<string, string | number> = {
      page: filters.page,
      limit: filters.limit,
    }
    if (filters.status) params.status = filters.status
    if (filters.voucher_type) params.voucher_type = filters.voucher_type
    if (filters.search) params.search = filters.search

    const { data } = await api.get('/vouchers/', { params })
    return data
  },

  getByClient: async (clientId: number): Promise<BenefitVoucher[]> => {
    const { data } = await api.get(`/vouchers/client/${clientId}`)
    return data
  },

  getByCode: async (code: string): Promise<BenefitVoucher> => {
    const { data } = await api.get(`/vouchers/${code}`)
    return data
  },

  redeem: async (code: string, payload: VoucherRedeemPayload): Promise<BenefitVoucher> => {
    const { data } = await api.put(`/vouchers/${code}/redeem`, payload)
    return data
  },
}
